import { loadScript } from '../../utils/common';
import { getAppEnv } from '../../utils/env';

export default {
    mounted() {
        const env = getAppEnv(window.navigator.userAgent);
        let sdk = '';
        switch (env.app) {
            case 'weapp':
                if (!window.wx.miniProgram) {
                    sdk = '//res.wx.qq.com/open/js/jweixin-1.0.0.js';
                }
                break;
            case 'alipay':
                if (!window.my) {
                    sdk = '//appx/web-view.min.js';
                }
                break;
            case 'swan':
                if (!window.swan.webView) {
                    sdk = '//b.bdstatic.com/searchbox/icms/searchbox/js/swan-2.0.31.js';
                }
                break;
            case 'tt':
                // 多次加载会报错
                if (!window.tt.miniProgram) {
                    sdk = '//lf3-cdn-tos.bytegoofy.com/obj/goofy/developer/jssdk/jssdk-1.2.1.js';
                }
                break;
            case 'ks':
                // 快手小程序web-view自动注入
                // https://mp.kuaishou.com/docs/develop/components/open/web-view.html#%E8%B7%AF%E7%94%B1
                break;
            default:
                break;
        }
        sdk && loadScript(sdk, 'body');
    },
    methods: {
        judgeFrom() {
            const env = getAppEnv(window.navigator.userAgent);
            if (env.isQuickApp || env.isMiniProgram) {
                return 'wapp'; // 小程序
            }
            if (location.origin.includes('api') || location.origin.includes('appsale')) {
                return 'app';
            }
            if (
                location.origin.includes('m.anjuke.') ||
                location.origin.includes('m.58.') ||
                location.origin.includes('msale.58.')
            ) {
                return 'tw';
            }
            return 'pc';
        }
    }
};
